import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";
import { GetProduct } from "../interface";

export const getProduct = async (
  page: number,
  limit: number,
  search: string = "",
  priceDifferenceOnly: boolean = false,
  priceChangeOnly: boolean = false,
  watchlistedOnly: boolean = false,
  sortBy: string = "created_at",
  sortOrder: string = "desc",
  competitorNames: string[] = []
): Promise<GetProduct> => {
  try {
    const params: Record<string, string> = {
      page: page.toString(),
      limit: limit.toString(),
      sortBy,
      sortOrder,
    };

    if (search.trim()) {
      params.search = search.trim();
    }

    if (priceDifferenceOnly) {
      params.priceDifferenceOnly = "true";
    }

    if (priceChangeOnly) {
      params.priceChangeOnly = "true";
    }

    if (watchlistedOnly) {
      params.watchlistedOnly = "true";
    }

    if (competitorNames.length > 0) {
      params.competitorNames = competitorNames.join(",");
    }

    return await apiRequest<GetProduct>("get", "/products", { params });
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to fetch products");
  }
};
